
import { makeAutoObservable, runInAction } from "mobx";
import { toast } from "react-toastify";
import { getOrderById } from "../services/OrderService";

export interface OrderStatus {
  id: number;
  status: {
    id: string;
    name: string;
  };
  created_at: string;
}

export interface OrderItem {
  product_id: number;
  quantity: number;
  price: string;
  total: string;
  product: {
    id: number;
    name: string;
    base_price: number;
    base_quantity: string;
    base_unit: string;
    sku?: string;
    tax: string
  };
  updatedQuantity?: {
    quantity: number;
  }[];
}

export interface User {
  id: number;
  name: string;
  email: string;
  mobile: string;
}

export interface OrderDetail {
  id: number;
  unique_id: string;
  created_at: string;
  total_amount: string;
  user: User;
  items: OrderItem[];
  statusHistory: OrderStatus[];
  salesReturns?: {
    history?: {
      items: {
        product_id: number;
        quantity: number;
      }[];
    };
  };
}

export default class OrderDetailStore {
  order: OrderDetail | null = null;
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  loadOrder = async (orderId: number) => {
    this.loading = true;
    try {
      const res = await getOrderById(orderId);
      if (res.status === "success") {
        runInAction(() => {
          this.order = res.data;
        });
      } else {
        toast.error(res.message || "Failed to load order");
      }
    } catch (error) {
      toast.error("Something went wrong while loading order.");
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };
}
